/**
 * Module state
 * Keeps track of original parameters, current parameters, and active parameter
 * Stores data needed to display parameter options (vendors, ships, etc)
 */
var State = Backbone.Model.extend({
  /**
   * Default data set from REVELEX object
   */
  defaults: {
    param_options:
      REVELEX && REVELEX.cruise && REVELEX.cruise.data
        ? REVELEX.cruise.data
        : {},
    tour_param_options: {},
    tour_data: [
      "vendors",
      "destinations"
    ] /* @todo removed 'ships', add back when DB data for ship tours is updated! */,
    search_params: {
      duration: {
        min: 0,
        max: 30
      },
      date_difference: {
        amount: 1,
        unit: "month"
      },
      cabin: 1,
      ships: [],
      vendors: [],
      portsOfCall: [],
      destinations: [],
      countries: [],
      cities: [],
      waterways: [],
      marketing_code: [],
      embarkationPorts: [],
      date_max: moment()
        .add(1, "day")
        .add(5, "years")
        .startOf("day"),
      date_min: moment()
        .add(1, "day")
        .startOf("day")
    },
    original_search_params:
      REVELEX && REVELEX.cruise && REVELEX.cruise.search_params
        ? REVELEX.cruise.search_params
        : {},
    output_date_format: "MM/DD/YYYY",
    active_param: null,
    active_type: null
  },
  /**
   * Initializes data
   * @param {object} options
   */
  initialize: function(options) {
    var original_search_params = {};
    var param_options = this.get("param_options");
    var tour_param_options = this.get("tour_param_options");
    var data_to_map = [
      "vendors",
      "ships",
      "destinations",
      "embarkationPorts",
      "portsOfCall",
      "countries",
      "cities",
      "waterways",
      "marketing_code"
    ];
    // Clear out selection (All Selected) if all vendors are returned as selected
    if (
      this.get("original_search_params").vendors &&
      this.get("original_search_params").vendors.length ==
        this.get("param_options").vendors.length
    ) {
      original_search_params = this.get("original_search_params");
      original_search_params.vendors = [];
      this.set("original_search_params", original_search_params);
    }

    if (this.get("original_search_params").countries) {
      // If countries provided, replace their codes with ids.
      original_search_params = this.get("original_search_params");
      var countries = [];

      // Find matching Countries by Code and replace with ID
      // This module expects IDs for proper functionality
      _.each(
        original_search_params.countries,
        function(country) {
          countries.push(
            _.findWhere(this.get("param_options").countries, {
              country_code: country
            }).country_id
          );
        }.bind(this)
      );

      original_search_params.countries = countries;
      this.set("original_search_params", original_search_params);
    }

    // for reseting cabin, marketing code and duration to default value
    cabin_default = this.get("search_params").cabin;
    marketing_code_default = this.get("search_params").marketing_code;
    duration_min = this.get("search_params").duration.min;
    duration_max = this.get("search_params").duration.max;

    // Set empty objects for lookup up by ID
    param_options.vendors_by_id = {};
    param_options.ships_by_id = {};
    param_options.countries_by_id = {};
    param_options.destinations_by_id = {};
    param_options.cities_by_id = {};
    param_options.waterways_by_id = {};

    // Map data options as object w/ IDs as key for fast lookup
    // Also filters each data option for tours
    _.each(
      data_to_map,
      function(name) {
        var check_tour = false;
        param_options[name + "_by_id"] = {};

        if (this.get("tour_data").indexOf(name) > -1) {
          tour_param_options[name] = [];
          check_tour = true;
        }

        _.each(param_options[name], function(item) {
          // Put in data by id
          var id_key =
            name === "embarkationPorts" || name === "portsOfCall"
              ? "port_id"
              : name.substring(0, name.length - 1) + "_id";
          id_key = name == "countries" ? "country_id" : id_key;
          id_key = name == "cities" ? "city_id" : id_key;
          param_options[name + "_by_id"][item[id_key]] = item;

          // Put in tour data
          if (check_tour && item.has_tours) {
            tour_param_options[name].push(item);
          }
        });
      }.bind(this)
    );

    // Copy original search parameters as current parameters
    // Quick deep copy via parse & stringify
    // Extends from defaults data structure
    this.set(
      "search_params",
      _.extend(
        this.get("search_params"),
        JSON.parse(JSON.stringify(this.get("original_search_params")))
      )
    );

    // Sets active search type
    this.set(
      "active_type",
      this.get("search_params").searchType
        ? this.get("search_params").searchType
        : "cruise_only"
    );
  },
  /**
   * Quick lookup for a piece of data
   * @example this.state.getDataById('vendors', 1)
   * @param {string} name
   * @param {int} id
   * @returns {*}
   */
  getDataById: function(name, id) {
    return this.get("param_options")[name + "_by_id"][id];
  },
  /**
   * Gets the list of options for a specified parameter
   * Takes into account the current search type
   * @param {string} name
   * @returns {array} options
   */
  getDataOptions: function(name) {
    var name = name || false;

    // If type is tour and we have tour options for the parameter, return
    if (
      this.get("active_type") === "cruise_tour" &&
      this.get("tour_param_options")[name]
    ) {
      return this.get("tour_param_options")[name];
    } else if (this.get("param_options")[name]) {
      // Otherwise if we have normal options, return
      // If is ship, check against vendors
      // @todo could be removed once DB ship tours data is updated
      if (name === "ships" && this.get("active_type") === "cruise_tour") {
        var ships = this.get("param_options")[name];
        var vendors = _.pluck(this.getDataOptions("vendors"), "vendor_id");
        return _.filter(ships, function(ship) {
          return vendors.indexOf(ship.vendor_id) > -1;
        });
      } else {
        return this.get("param_options")[name];
      }
    } else {
      // Otherwise return empty array
      return [];
    }
  },
  /**
   * @returns {Date} start date
   */
  getStartDate: function() {
    return moment(
      this.get("search_params").start_date,
      this.get("search_params").date_format
    ).toDate();
  },
  /**
   * @returns {Date} end date
   */
  getEndDate: function() {
    return moment(
      this.get("search_params").end_date,
      this.get("search_params").date_format
    ).toDate();
  }
});

/**
 * Module controller
 * Creates and initializes views
 * this.model is the State object
 */
var Controller = Backbone.View.extend({
  /**
   * Initializes module
   * @returns {Controller} this
   */
  initialize: function() {
    this.model = new State();
    this.createViews();
    this.$("input").blur();

    this.model.trigger("changed_param");
    this.model.trigger("changed_params");
    this.listenTo(
      this.model,
      "change:active_param",
      this.setActiveParam.bind(this)
    );
    this.listenTo(
      this.model,
      "change:active_type",
      this.setActiveType.bind(this)
    );
    this.inputGroup = this.$el.find("[data-param-options-group]");
    // To close the the search options upon outside click add data-outside-click-close=true
    this.autoClose = this.$el.data("outsideClickClose");
    var configInput = $("[data-configuration-input]");

    // For toggling the no: of months with viewport width add data-responsive-calendar-months
    // eg: data-responsive-calendar-months-count = '{"desktop": 3 , "tablet" : 2 , "mobile" : 1}'
    if (this.$el.data("responsiveCalendarMonths")) {
      $(window).on(
        "resize.calendar" + this.cid,
        this.toggleMonthsCount.bind(this)
      );
      $(window).trigger("resize.calendar" + this.cid);
    }
    if (configInput.length) {
      configInput.on("change", this.setConfigurationId.bind(this));
      this.setConfigurationId();
    }
    // If custom vendors list is defined in configs
    if (this.$el.data("customVendors")) {
      var vendorsList = [];
      customVendors = this.$el.data("customVendors");
      //update the vendors with custom list
      var vendors = _.pluck(
        this.model.get("param_options").vendors,
        "vendor_id"
      );
      var vendorsList = _.filter(
        this.model.get("param_options").vendors,
        function(vendor) {
          return customVendors.indexOf(vendor.vendor_id) > -1;
        }
      );
      this.model.get("param_options").vendors = vendorsList;
      //update the ships according to vendors
      var vendors = _.pluck(
        this.model.get("param_options").vendors,
        "vendor_id"
      );
      var shipsList = _.filter(this.model.get("param_options").ships, function(
        ship
      ) {
        return vendors.indexOf(ship.vendor_id) > -1;
      });
      this.model.get("param_options").ships = shipsList;
    }
    // If popular vendors are defined in config file
    if (this.$el.data("mostPopularVendors")) {
      var customPopularVendors = this.$el.data("mostPopularVendors"),
        vendors = this.model.get("param_options").vendors;
      _.filter(vendors, function(vendor) {
        //add the attribute popular when the vendor id IS FOUND in customPopularVendors list
        if (customPopularVendors.indexOf(vendor.id) > -1) {
          vendor.popular = true;
        }
      });
      this.model.get("param_options").vendors = vendors;
    }
    //If popular destinations list is defined in the config file
    if (this.$el.data("mostPopularDestinations")) {
      var customPopularDestinations = this.$el.data("mostPopularDestinations"),
        destinations = this.model.get("param_options").destinations;
      _.filter(destinations, function(destination) {
        //add the attribute popular when the vendor id IS FOUND in customPopularVendors list
        if (customPopularDestinations.indexOf(destination.id) > -1) {
          destination.popular = true;
        }
      });
      this.model.get("param_options").destinations = destinations;
    }

    //when the param remains as active on initialize
    if (this.model.get("active_param")) {
      this.model.set("active_param", null);
    }

    return this;
  },
  events: {
    "click [data-reset]": "resetParams",
    "input [data-option-filter]": "filter",
    submit: "onSubmit"
  },
  toggleMonthsCount: function() {
    var active_param = this.model.get("active_param");
    var active_view = this.views[active_param];
    // specify data-desktop-width attribute if the breakpoint for desktop is other than 1024px
    this.desktopWidth = this.$el.data("desktopWidth") || "1024px";
    this.MonthsCount = this.$el.data("responsiveCalendarMonths");
    isDesktop = window.matchMedia("(min-width: " + this.desktopWidth + ")");
    isTablet = window.matchMedia("(min-width: 767px)");
    if (isDesktop.matches) {
      this.views.startDate.calendar.settings.show_months = this.MonthsCount.desktop;
      this.views.endDate.calendar.settings.show_months = this.MonthsCount.desktop;
    } else if (isTablet.matches) {
      this.views.startDate.calendar.settings.show_months = this.MonthsCount.tablet;
      this.views.endDate.calendar.settings.show_months = this.MonthsCount.tablet;
    } else {
      this.views.startDate.calendar.settings.show_months = this.MonthsCount.mobile;
      this.views.endDate.calendar.settings.show_months = this.MonthsCount.mobile;
    }
    if (active_view) {
      active_view.renderOptions();
    }
  },
  hideOnClick: function(e) {
    if (
      !this.$el.is(e.target) &&
      !this.$(e.target).length &&
      !(
        $(e.target).is("[data-option-id]") ||
        $(e.target).is("[data-option-id] p") ||
        $(e.target).is("[data-option-reset]") ||
        $(e.target).is("[data-duration-action]") ||
        $(e.target).is("[data-prev-month]") ||
        $(e.target).is("[data-next-month]")
      )
    ) {
      this.model.set("active_param", "");
      $("body").removeClass("close-search-on-outside-click");
    }
  },
  onSubmit: function() {
    Backbone.Events.trigger("loadingSplashOn");
  },
  setConfigurationId: function() {
    var input = $("[data-configuration-input]"),
      output = $("[data-configuration-output]");

    if (input.length && output.length) {
      output.val(input.find(":selected").val());
    }

    return this;
  },
  /**
   * Creates views for each parameter and passes context (this) to each of them
   * @returns {Controller} this
   */
  createViews: function() {
    this.views = this.views || {};
    // Loops through data-param fields in template to create Views into this.views object.
    this.$("[data-param]").each(
      function(i, view) {
        var param = $(view).data("param");
        if (_.has(ParamViews, param + "View")) {
          this.views[param] = new ParamViews[param + "View"]({
            el: view,
            context: this
          });
        } else {
          console.warn("Param -" + param + "- doesn't have a view declared.");
        }
      }.bind(this)
    );

    // Creates options and inputs views which are always required by the module.
    this.views["param-options"] = new ParamOptionsView({
      el: this.$("[data-param-options]"),
      context: this
    });
    this.views["param-inputs"] = new ParamInputsView({
      el: this.$("[data-param-inputs]"),
      context: this
    });
    return this;
  },
  /**
   * Runs when model (state) active parameter is changed
   * @returns {Controller} this
   */
  setActiveParam: function() {
    var active_param = this.model.get("active_param");
    var active_view = this.views[active_param];
    var scroll_height = $("header").length
      ? $("header").outerHeight() + 40
      : false;

    // If the view exists, open its options
    if (active_view) {
      // Remove active class on container
      this.$el[0].className = this.$el[0].className
        .split(" ")
        .filter(function(c) {
          return c.lastIndexOf("is-active-", 0) !== 0;
        })
        .join(" ");
      // Set active class on container
      this.$el.addClass("is-active-" + active_param);
      this.inputGroup.addClass("is-active");

      if (false) {
        setTimeout(function() {
          $("html, body").animate(
            {
              scrollTop: active_view.$el.offset().top - scroll_height
            },
            1500
          );
        }, 400);
      }

      // Set/remove active class on params
      _.each(
        this.views,
        function(view) {
          if (view.name === active_param) {
            view.$el.addClass("is-active");
            if (this.autoClose) {
              // Adding class to the body to target click on ios devices
              $("body").addClass("close-search-on-outside-click");
            }
          } else {
            view.$el.removeClass("is-active");
          }

          if (active_param == null) {
            this.inputGroup.removeClass("is-active");
          }
        }.bind(this)
      );

      // Render the options for param
      active_view.renderOptions();

      if (this.autoClose) {
        $("body").on("click.overlay." + this.cid, this.hideOnClick.bind(this));
      }
    } else {
      // Otherwise remove classes and close options
      // Remove active class on container
      this.$el[0].className = this.$el[0].className
        .split(" ")
        .filter(function(c) {
          return c.lastIndexOf("is-active-", 0) !== 0;
        })
        .join(" ");
      this.inputGroup.removeClass("is-active");
      // Remove active classes on params
      _.each(this.views, function(view) {
        view.$el.removeClass("is-active");
      });

      if (this.autoClose) {
        $(document).off("click.overlay." + this.cid);
        $("body").removeClass("close-search-on-outside-click");
      }
    }

    return this;
  },
  /**
   * Runs when model (state) active search type is changed
   * Audits the currently selected parameters and triggers re-render
   * @returns {Controller} this
   */
  setActiveType: function() {
    var active_param = this.model.get("active_param");
    var active_view = this.views[active_param];

    // If type was changed to tour, clear out current search params that are do not have tour
    if (this.model.get("active_type") === "cruise_tour") {
      var search_params = this.model.get("search_params");
      var tour_data = this.model.get("tour_data");

      // Looks at only parameters that have tour data
      _.each(
        tour_data,
        function(name) {
          if (search_params[name] && search_params[name].length > 0) {
            // List to hold audited values
            var new_list = [];

            // If data has tours, add it to the list
            _.each(
              search_params[name],
              function(id) {
                var item = this.model.getDataById(name, id);
                if (item && item.has_tours) {
                  new_list.push(id);
                }
              }.bind(this)
            );

            // Sets list of audited values
            search_params[name] = new_list;
          }
        }.bind(this)
      );

      // Trigger repainting of param values
      this.model.trigger("changed_params");
    }

    // Repaint active param
    if (active_view) {
      active_view.renderOptions();
    }

    return this;
  },
  /**
   * Resets each parameter
   * @returns {Controller} this
   */
  resetParams: function() {
    if (this.views["searchType"]) {
      this.views["searchType"].setSearchType();
    }

    // Reset all other views
    _.each(this.views, function(view) {
      if (typeof view.reset === "function") {
        view.reset();
      }
    });
    return this;
  }
});

/**
 * Base view that each parameter view extends from
 * Provides common functionality and methods that can be overwritten
 * this.context is the Controller
 * this.context.model is the State
 */
var ParamView = Backbone.View.extend({
  /**
   * Initializes the view
   * Sets name ('startDate', 'vendors', etc), context, and filter
   * Runs compilations and binds events
   * @param {object} options
   * @returns {ParamView} this
   */
  initialize: function(options) {
    var options = options || {};
    this.name = this.$el.attr("data-param");
    this.context = options.context ? options.context : {};
    this.filter = "";
    this.compileTemplates().getTargets();
    this.bindEvents().bindAdditionalEvents();
    this.afterInitialize();
    //Removing loading circle from each form field that has data-custom-loader attribute
    $("[data-custom-loader]").removeClass("is-loading");

    return this;
  },
  /**
   * Placeholder method that can be overwritten
   * Runs during initialization after events are bound
   * @returns {ParamView} this
   */
  afterInitialize: function() {
    return this;
  },
  events: {
    "click [data-param-trigger]": "setActiveParam"
  },
  /**
   * When parameter is clicked, set it as the active parameter
   * @returns {ParamView} this
   */
  setActiveParam: function(e) {
    if (this.context.model.get("active_param") !== this.name) {
      this.context.model.set("active_param", this.name);
    } else {
      this.context.model.set("active_param", null);
    }

    if (_.isFunction(this.afterActivate)) {
      this.afterActivate(e);
    }
    return this;
  },
  /**
   * Bind events for all parameters
   * @returns {ParamView} this
   */
  bindEvents: function() {
    // When parameters change, render the value ('2 Destinations', '1-8 Nights' etc)
    this.listenTo(
      this.context.model,
      "changed_params",
      this.renderValue.bind(this)
    );
    return this;
  },
  /**
   * Placeholder method that can be overwritten
   * Runs during initialization after default events are bound
   * @returns {ParamView} this
   */
  bindAdditionalEvents: function() {
    return this;
  },
  /**
   * Sets targets based on this.$el's contents
   * this.targets is a keyed object containing named [data-target] elements
   * @example this.targets = {'value': [jQuery element]}
   * @returns {ParamView} this
   */
  getTargets: function() {
    this.targets = this.targets || {};
    this.$("[data-target]").each(
      function(index, element) {
        var $target = $(element);
        this.targets[$target.attr("data-target")] = $target;
      }.bind(this)
    );
    return this;
  },
  /**
   * Sets templates based on this.$el's contents
   * this.templates is a keyed object containing named compiled [data-template] Handlebars templates
   * @example this.templates = {'value': [Handlebars template], 'option': [Handlebars template]}
   * @returns {ParamView} this
   */
  compileTemplates: function() {
    this.templates = this.templates || {};
    this.$("[data-template]").each(
      function(index, element) {
        var $template = $(element);
        this.templates[$template.attr("data-template")] = Handlebars.compile(
          $template.html()
        );
      }.bind(this)
    );
    return this;
  },
  /**
   * Update target element with rendered template
   * Can also pass data to the template to render with
   * @example this.updateTarget({ target: 'value', template: 'value', data: {port: {...}, length: 2} })
   * @param {object} options
   * @returns {ParamView} this
   */
  updateTarget: function(options) {
    var options = options || {};
    options.target = options.target || "";
    options.template = options.template || "";
    options.data = options.data || {};

    if (this.targets[options.target] && this.templates[options.template]) {
      // Check if it's an input or a span
      if (this.targets[options.target].get(0).tagName == "INPUT") {
        this.targets[options.target].val(
          moment(options.data.date).format(
            this.calendar.settings.date_input_format
          )
        );
      } else {
        this.targets[options.target]
          .empty()
          .append(this.templates[options.template](options.data));
      }
    }

    return this;
  },
  /**
   * Placeholder method to be overwritten
   * Responsible for rendering the display value based on parameter's selected option(s)
   * i.e. '2 Destinations' or '1-8 Nights'
   * @returns {ParamView} this
   */
  renderValue: function() {
    return this;
  },
  /**
   * Placeholder method to be overwritten
   * Responsible for rendering the parameter's options
   * @returns {ParamView} this
   */
  renderOptions: function() {
    return this;
  },
  /**
   * Reset parameter method
   * Can be overwritten
   * @returns {ParamView} this
   */
  reset: function() {
    this.filter = "";
    this.context.model.get("search_params")[this.name] = [];
    this.renderValue();
    if (this.context.model.get("active_param") === this.name) {
      this.renderOptions();
    } else {
      this.renderValue();
    }
    return this;
  }
});

/**
 * Import Calendar module as a class
 */
var Calendar = $.getComponent("calendar");

/**
 * Object that contains all the Param Views
 */
var ParamViews = {};

/**
 * View for search type (cruise/cruise tour)
 */
ParamViews.searchTypeView = Backbone.View.extend({
  /**
   * Initializes the view
   * Sets name and context
   * @param {object} options
   * @returns {SearchTypeView} this
   */
  initialize: function(options) {
    var options = options || {};
    this.name = this.$el.attr("data-param");
    this.context = options.context ? options.context : {};
    return this;
  },
  events: {
    "change [data-search-type]": "changeSearchType"
  },
  /**
   * Runs when search type is changed
   * @returns {SearchTypeView} this
   */
  changeSearchType: function(e) {
    this.context.model.set("active_type", $(e.target).val());
    return this;
  },
  /**
   * Sets the search type in DOM programatically
   * Used by Controller.reset()
   * @returns {SearchTypeView} this
   */
  setSearchType: function() {
    var type = this.context.model.get("active_type");
    this.$("[data-search-type]").each(function() {
      var $input = $(this);
      if ($input.val() === type) {
        $input[0].checked = true;
      } else {
        $input[0].checked = false;
      }
    });
    return this;
  }
});

var CalendarViews = ParamView.extend({
  events: {
    "click [data-param-trigger]": "setActiveParam",
    "focus [data-target]": "ensureOpen",
    "blur [data-target]": "checkReset",
    "click [data-target]": "ensureOpen",
    "keyup [data-target]": "valueChecks",
    "dblclick [data-select-all]": "selectAll"
  },
  ensureOpen: function(e) {
    e.stopPropagation();
    if (!this.isActive()) {
      this.context.model.set("active_param", this.name);
    }
  },
  /*
   * Select all text on double click
   */
  selectAll: function(e) {
    $(e.currentTarget).select();
  },

  valueChecks: function(e) {
    if (!this.calendar.state.selected_date) {
      return false;
    }

    var currentDate = this.calendar.state.selected_date.format(
      this.calendar.settings.date
    );

    var inputDate = this.targets.value[0].value.replace(/[^0-9\-\.|\/]/g, "");

    if (currentDate.length == inputDate.length && currentDate !== inputDate) {
      this.calendar.settings.date = inputDate;
      this.state = this.calendar.setDate(
        this.calendar.settings.date,
        true,
        false,
        true
      );

      if ((this.type = "end")) {
        this.$el
          .parents("[data-param]")
          .next("[data-param]")
          .find("[data-param-trigger]")
          .trigger("click");
      }
    }

    return this;
  },
  checkReset: function(e) {
    if (!this.calendar.state.selected_date) {
      return false;
    }
    var currentDate = this.calendar.state.selected_date.format(
      this.calendar.settings.date
    );
    var inputDate = this.targets.value[0].value.replace(/[^0-9\-\.|\/]/g, "");

    if (currentDate.length != inputDate.length) {
      this.targets.value[0].value = currentDate;
    }
  },
  setActiveParam: function(e) {
    if (!this.isActive()) {
      this.context.model.set("active_param", this.name);
    } else {
      this.context.model.set("active_param", null);
    }
    if (_.isFunction(this.afterActivate)) {
      this.afterActivate(e);
    }

    return this;
  },
  /**
   * Renders the calendars
   * This method is passed to the Calendar upon initialization
   * Re-renders the value as well
   * @returns {EndDateView} this
   */
  renderOptions: function() {
    if (this.context.model.get("active_param") === this.name) {
      this.context.views["param-options"].render({
        content: this.calendar.renderDate()
      });
      this.calendar.setElement(
        this.context.views["param-options"].$("[data-calendar]")
      );
      var outputFormat = this.calendar.settings.date_output_format.replace(
        /[a-zA-Z]/gi,
        "9"
      );
      this.targets.value.inputmask(outputFormat, {
        placeholder: this.calendar.settings.date_input_format
      });
    }

    if (document.documentElement.clientWidth > 1280) {
      this.targets.value.select();
    }

    this.renderValue();
    return this;
  },
  isActive: function() {
    return this.context.model.get("active_param") == this.name;
  }
});

/**
 * View for start date
 * @extends ParamView
 */
ParamViews.startDateView = CalendarViews.extend({
  /**
   * After initialization, create a new Calendar and pass custom template and custom render function
   * @returns {StartDateView} this
   */
  afterInitialize: function() {
    var search_params = this.context.model.get("search_params"),
      settings = {
        type: "start",
        name: "CRUISE_MODIFY_SEARCH",
        date: search_params.start_date,
        show_months: this.$el.data("show-months") || 3,
        date_min: search_params.date_min,
        date_max: search_params.date_max,
        date_display_format: search_params.date_format,
        date_input_format: search_params.date_format,
        date_output_format: search_params.date_format,
        date_template: this.templates["options"],
        date_render: this.renderOptions.bind(this)
      };
    settings = $.extend(settings, this.$el.data("settings"));

    this.type = "start";

    this.calendar = new Calendar({
      settings: settings
    });
    // When calendar fires date changed, bind event
    this.calendar.on("changed:date", this.handleSelectDay.bind(this));

    // Keep keyboard from showing when interacting with calendars on tablet and smaller devices
    var readonlyState =
      document.documentElement.clientWidth > 1280 ? false : "";
    this.targets.value.attr("readonly", readonlyState);

    return this;
  },
  /**
   * Update calendar with manually added input
   */
  updateCalendar: function() {
    var currentDate = this.calendar.state.selected_date.format(
      this.calendar.settings.date
    );
    var inputDate = this.targets.value[0].value.replace(/[^0-9\-|\/]/g, "");

    if (
      currentDate.length == inputDate.length &&
      currentDate !== this.calendar.date
    ) {
      this.calendar.settings.date = inputDate;
      this.calendar.setDate(this.calendar.settings.date, true, false, true);
    }
    // this.calendar.settings.date_input_format
    return this;
  },
  /**
   * Input Conditions
   * Prepares textbox for manual input
   */
  afterActivate: function(e) {
    if ($(e.target).is("[data-target]")) {
      $(this.targets.value).inputmask("99/99/9999", {
        placeholder: this.calendar.settings.date_input_format
      });
    } else {
      this.calendar.render();
    }

    return this;
  },
  /**
   * Runs when calendar fires date changed event
   * Re-render the value and trigger additional events
   * @param {object} data
   * @param {string} data.date
   * @returns {StartDateView} this
   */
  handleSelectDay: function(data) {
    var search_params = this.context.model.get("search_params");
    var data = data || {};
    if (data.date) {
      search_params.start_date = data.date;
      //maximum selctable From Date is set to 6 months plus the selected To Date
      maxEndDate = moment(data.date, this.calendar.settings.date_input_format)
        .add(1, "day")
        .add(6, "months")
        .startOf("day");
      if (this.calendar.settings.date_max.diff(maxEndDate) > 0) {
        search_params.date_max = maxEndDate;
      }
      this.context.model.trigger("change:search_params.date_max");

      //set To Date to 1 month plus From Date
      endDate = moment(data.date, this.calendar.settings.date_input_format).add(
        search_params.date_difference.amount,
        search_params.date_difference.unit
      );
      if (this.calendar.settings.date_max.diff(endDate) > 0) {
        search_params.end_date = endDate;
      } else {
        search_params.end_date = this.calendar.settings.date_max;
      }
      this.context.model.trigger("change:search_params.end_date");

      this.renderValue();
      this.context.model
        .trigger("changed_" + this.context.model.get("active_param"))
        .set("active_param", "endDate")
        .trigger("changed_param");
    }
    return this;
  },
  /**
   * Renders the value
   * i.e. '9/25/2015'
   * @returns {StartDateView} this
   */
  renderValue: function() {
    this.updateTarget({
      target: "value",
      template: "value",
      data: { date: this.context.model.getStartDate() }
    });
    return this;
  },
  /**
   * Resets back to original start date
   * @returns {StartDateView} this
   */
  reset: function() {
    this.calendar.setDate(this.calendar.settings.date_min, true);
    return this;
  }
});

/**
 * View for end date
 * @extends ParamView
 */
ParamViews.endDateView = CalendarViews.extend({
  /**
   * After initialization, create a new Calendar and pass custom template and custom render function
   * @returns {EndDateView} this
   */
  afterInitialize: function() {
    var search_params = this.context.model.get("search_params"),
      settings = {
        type: "end",
        name: "CRUISE_MODIFY_SEARCH",
        date: search_params.end_date,
        end_date: moment(search_params.date_min, search_params.date_format).add(
          search_params.date_difference.amount,
          search_params.date_difference.unit
        ),
        show_months: this.$el.data("show-months") || 3,
        date_difference: this.$el.data("date-difference") || {
          amount: 1,
          unit: "month"
        },
        date_min: search_params.start_date,
        date_max: moment(search_params.start_date, search_params.date_format)
          .add(1, "day")
          .add(6, "months")
          .startOf("day"),
        date_display_format: search_params.date_format,
        date_input_format: search_params.date_format,
        date_output_format: search_params.date_format,
        date_template: this.templates["options"],
        date_render: this.renderOptions.bind(this)
      };

    settings = $.extend(settings, this.$el.data("settings"));

    this.type = "end";

    this.calendar = new Calendar({
      settings: settings
    });

    // Keep keyboard from showing when interacting with calendars on tablet and smaller devices
    var readonlyState =
      document.documentElement.clientWidth > 1280 ? false : "";
    this.targets.value.attr("readonly", readonlyState);

    // When calendar fires date changed, bind event
    this.context.model.on(
      "change:search_params.date_max",
      this.maxEndDate,
      this
    );
    this.context.model.on("change:search_params.end_date", this.endDate, this);
    this.calendar.on("changed:date", this.handleSelectDay.bind(this));

    return this;
  },
  /**
   * Input Conditions
   * Prepares textbox for manual input
   */
  afterActivate: function(e) {
    if ($(e.target).is("[data-target]")) {
      $(this.targets.value).inputmask("99/99/9999", {
        placeholder: this.calendar.settings.date_input_format
      });
      $(this.targets.value[0]).select();
    } else {
      this.calendar.render();
    }
    return this;
  },
  /**
   * Update calendar with manually added input
   */
  updateCalendar: function() {
    this.calendar.settings.date = this.targets.value[0].value;
    this.calendar.setDate(this.calendar.settings.date, true, false, true);
    return this;
  },
  /**
   * Runs when calendar fires date changed event
   * Re-render the value and trigger additional events
   * @param {object} data
   * @param {string} data.date
   * @returns {EndDateView} this
   */
  handleSelectDay: function(data) {
    var data = data || {};
    if (data.date) {
      this.context.model.get("search_params").end_date = data.date;
      this.renderValue();
      this.context.model
        .trigger("changed_" + this.context.model.get("active_param"))
        .set("active_param", null)
        .trigger("changed_param");
    }
    return this;
  },
  maxEndDate: function() {
    this.calendar.settings.date_max = moment(
      this.context.model.get("search_params").date_max
    );
    this.renderValue();
  },
  endDate: function() {
    this.calendar.state.selected_date = moment(
      this.context.model.get("search_params").end_date
    );
    this.calendar.state.current_month = moment(
      this.calendar.state.selected_date
    ).startOf("month");
    this.calendar.state.current_year = moment(
      this.calendar.state.selected_date
    ).startOf("year");
    this.calendar.trigger("changed:date", {
      date: moment(this.context.model.get("search_params").end_date).format(
        this.calendar.settings.date_output_format
      )
    });
  },
  /**
   * Renders the value
   * i.e. '9/25/2015'
   * @returns {EndDateView} this
   */
  renderValue: function() {
    this.updateTarget({
      target: "value",
      template: "value",
      data: { date: this.context.model.getEndDate() }
    });
    return this;
  },
  /**
   * Resets back to original end date
   * @returns {EndDateView} this
   */
  reset: function() {
    this.calendar.setDate(this.calendar.settings.end_date, true);
    return this;
  }
});

/**
 * View for vendors/cruise lines
 * @extends ParamView
 */
ParamViews.vendorsView = ParamView.extend({
  /***
   * Initialize cruise tours vendors selected
   *
   * @returns {vendorsView} this
   */
  afterInitialize: function() {
    // Filtering vendor selection for Cruise Tour
    if (this.context.model.get("active_type") == "cruise_tour") {
      var vendors = [],
        tour_vendors = this.context.model.get("tour_param_options").vendors;

      if (this.context.model.get("search_params").vendors.length > 0) {
        _.each(
          this.context.model.get("search_params").vendors,
          function(vendor_id) {
            _.each(tour_vendors, function(tour_vendor) {
              if (tour_vendor.id == vendor_id) {
                vendors.push(vendor_id);
              }
            });
          }.bind(this)
        );
      } else {
        _.each(tour_vendors, function(tour_vendor) {
          vendors.push(tour_vendor.id);
        });
      }

      this.context.model.get("search_params").vendors = vendors;
    }
    return this;
  },
  /**
   * Bind additional events
   * @returns {VendorsView} this
   */
  bindAdditionalEvents: function() {
    // When ships selection is changed, handle it
    this.listenTo(
      this.context.model,
      "changed_ships",
      this.handleShipChange.bind(this)
    );
    return this;
  },
  /**
   * Runs when ships are changed
   * If a ship is picked that is not from a currently selected vendor, select that vendor
   * @returns {VendorsView} this
   */
  handleShipChange: function() {
    var vendors = this.context.model.get("search_params").vendors;
    var ships = this.context.model.get("search_params").ships;
    if (ships.length) {
      _.each(
        ships,
        function(ship_id) {
          var ship_vendor = this.context.model.getDataById("ships", ship_id)
            .vendor_id;
          if (vendors.indexOf(ship_vendor) === -1) {
            vendors.push(ship_vendor);
          }
        }.bind(this)
      );
      this.renderValue();
    }
    return this;
  },
  /**
   * Render display value
   * i.e. '2 Cruise Line', 'Carnival Cruise Line'
   * @returns {VendorsView} this
   */
  renderValue: function() {
    var vendors = this.context.model.get("search_params").vendors;
    var data = {
      length: vendors.length,
      vendor:
        vendors.length === 1
          ? this.context.model.getDataById("vendors", vendors[0])
          : null
    };

    this.updateTarget({
      target: "value",
      template: "value",
      data: data
    });
    return this;
  },
  /**
   * Render list of vendor options
   * If there is a user typed filter, test against the vendor's name
   * @returns {VendorsView} this
   */
  renderOptions: function() {
    var selected = this.context.model.get("search_params").vendors;
    var options = this.context.model.getDataOptions("vendors");
    var popularVendors = false;

    _.each(
      options,
      function(option, index) {
        if (selected.indexOf(option.vendor_id) > -1) {
          option.selected = true;
        } else {
          option.selected = false;
        }
        if (option.popular) {
          popularVendors = true;
        }

        if (
          !this.filter.trim() ||
          (this.filter.trim() &&
            option.vendor_name
              .toLowerCase()
              .indexOf(this.filter.trim().toLowerCase()) > -1)
        ) {
          option.show = true;
        } else {
          option.show = false;
        }
      }.bind(this)
    );

    options = _.sortBy(options, function(option) {
      return option.vendor_name.toLowerCase();
    });

    var content = this.templates["options"]({
      filter: this.filter,
      options: options,
      selected: selected,
      popularVendors: popularVendors
    });
    this.context.views["param-options"].render({ content: content });
    this.renderValue();
    return this;
  },
  /**
   * Reset list of ships (if there are no vendors selected, all ships should be available)
   * Reset list of vendors
   * @returns {VendorsView} this
   */
  reset: function() {
    this.context.views["ships"].reset();
    return ParamView.prototype.reset.call(this, arguments);
  }
});

/**
 * View for cruise ships
 * @extends ParamView
 */
ParamViews.shipsView = ParamView.extend({
  /**
   * Bind additional events
   * @returns {ShipsView} this
   */
  bindAdditionalEvents: function() {
    // When vendors selection is changed, handle it
    this.listenTo(
      this.context.model,
      "changed_vendors",
      this.handleVendorChange.bind(this)
    );
    return this;
  },
  /**
   * Runs when vendors are changed
   * From the current list of ships, remove ones that are not from currently selected vendors
   * @returns {ShipsView} this
   */
  handleVendorChange: function() {
    var vendors = this.context.model.get("search_params").vendors;
    var ships = this.context.model.get("search_params").ships;
    if (vendors.length && ships.length) {
      var new_ships = [];
      _.each(
        ships,
        function(ship_id) {
          if (
            vendors.indexOf(
              this.context.model.getDataById("ships", ship_id).vendor_id
            ) > -1
          ) {
            new_ships.push(ship_id);
          }
        }.bind(this)
      );
      this.context.model.get("search_params").ships = new_ships;
      this.renderValue();
    }
    return this;
  },
  /**
   * Renders display value
   * i.e. '2 Ship'
   * @returns {ShipsView} this
   */
  renderValue: function() {
    var ships = this.context.model.get("search_params").ships;
    var data = {
      length: ships.length,
      ship:
        ships.length === 1
          ? this.context.model.getDataById("ships", ships[0])
          : null
    };
    this.updateTarget({
      target: "value",
      template: "value",
      data: data
    });
    return this;
  },
  /**
   * Render list of ship options
   * If there is a user typed filter, test against the ship's name
   * @returns {ShipsView} this
   */
  renderOptions: function() {
    var selected = this.context.model.get("search_params").ships;
    var options = this.context.model.getDataOptions("ships");

    // Set empty object for ships by vendor
    var options_by_vendor = {};

    _.each(
      options,
      function(option) {
        if (selected.indexOf(option.ship_id) > -1) {
          option.selected = true;
        } else {
          option.selected = false;
        }

        if (
          !this.filter.trim() ||
          (this.filter.trim() &&
            option.ship_name
              .toLowerCase()
              .indexOf(this.filter.trim().toLowerCase()) > -1)
        ) {
          option.show = true;
        } else {
          option.show = false;
        }

        if (
          option.show &&
          this.context.model.get("search_params").vendors.length > 0 &&
          this.context.model
            .get("search_params")
            .vendors.indexOf(option.vendor_id) < 0
        ) {
          option.show = false;
        }

        // Adds ship data grouped by Vendor in options_by_vendor object
        if (typeof options_by_vendor[option.vendor_name] === "undefined") {
          options_by_vendor[option.vendor_name] = {
            options: [],
            total_visible: 0
          };
        }
        options_by_vendor[option.vendor_name].options.push(option);

        if (option.show) {
          options_by_vendor[option.vendor_name].total_visible++;
        }
      }.bind(this)
    );

    var content = this.templates["options"]({
      filter: this.filter,
      options: options,
      options_by_vendor: options_by_vendor,
      selected: selected
    });
    this.context.views["param-options"].render({ content: content });
    this.renderValue();
    return this;
  }
});

/**
 * View for destinations
 * @extends ParamView
 */
ParamViews.destinationsView = ParamView.extend({
  /**
   * Renders display value
   * i.e. '2 Destinations'
   * @returns {DestinationsView} this
   */
  renderValue: function() {
    var destinations = this.context.model.get("search_params").destinations;
    var data = {
      length: destinations.length,
      destination:
        destinations.length === 1
          ? this.context.model.getDataById("destinations", destinations[0])
          : null
    };

    this.updateTarget({
      target: "value",
      template: "value",
      data: data
    });
    return this;
  },
  /**
   * Render list of destination options
   * If there is a user typed filter, test against the destination's name
   * @returns {DestinationsView} this
   */
  renderOptions: function() {
    var selected = this.context.model.get("search_params").destinations;
    var options = this.context.model.getDataOptions("destinations");
    var popularDestinations = false;

    var usAliases = ["us", "usa"];

    var inputValue = this.filter;

    if (
      usAliases.indexOf(this.filter.toLowerCase().replace(/\s|\./g, "")) > 0 &&
      REVELEX.settings.currentLocale != "de-CH"
    ) {
      this.filter = "U. S.";
    }

    _.each(
      options,
      function(option, index) {
        if (selected.indexOf(option.destination_id) > -1) {
          option.selected = true;
        } else {
          option.selected = false;
        }
        if (option.popular) {
          popularDestinations = true;
        }

        if (
          !this.filter.trim() ||
          (this.filter.trim() &&
            option.destination_name
              .toLowerCase()
              .indexOf(this.filter.trim().toLowerCase()) > -1)
        ) {
          option.show = true;
        } else {
          option.show = false;
        }
      }.bind(this)
    );
    options = _.sortBy(options, function(option) {
      return option.destination_name.toLowerCase();
    });

    var content = this.templates["options"]({
      inputValue: inputValue,
      filter: this.filter,
      options: options,
      selected: selected,
      popularDestinations: popularDestinations
    });
    this.context.views["param-options"].render({ content: content });
    this.renderValue();
    return this;
  }
});

/**
 * View for Countries
 * @extends ParamView
 */
ParamViews.countriesView = ParamView.extend({
  /**
   * Renders display value
   * i.e. '2 Destinations'
   * @returns {DestinationsView} this
   */
  renderValue: function() {
    var countries = this.context.model.get("search_params").countries;

    var data = {
      length: countries.length,
      country:
        countries.length == 1
          ? this.context.model.getDataById("countries", countries[0])
          : null
    };

    this.updateTarget({
      target: "value",
      template: "value",
      data: data
    });
    return this;
  },
  /**
   * Render list of destination options
   * If there is a user typed filter, test against the destination's name
   * @returns {DestinationsView} this
   */
  renderOptions: function() {
    var selected = this.context.model.get("search_params").countries;
    var options = this.context.model.getDataOptions("countries");

    _.each(
      options,
      function(option, index) {
        if (selected.indexOf(option.country_id) > -1) {
          option.selected = true;
        } else {
          option.selected = false;
        }

        if (
          !this.filter.trim() ||
          (this.filter.trim() &&
            option.country_name
              .toLowerCase()
              .indexOf(this.filter.trim().toLowerCase()) > -1)
        ) {
          option.show = true;
        } else {
          option.show = false;
        }
      }.bind(this)
    );

    options = _.sortBy(options, function(option) {
      return option.country_name.toLowerCase();
    });

    var content = this.templates["options"]({
      filter: this.filter,
      options: options,
      selected: selected
    });
    this.context.views["param-options"].render({ content: content });
    this.renderValue();
    return this;
  }
});

/**
 * View for Regions
 * @extends ParamView
 */
ParamViews.citiesView = ParamView.extend({
  /**
   * Renders display value
   * i.e. '2 Destinations'
   * @returns {DestinationsView} this
   */
  renderValue: function() {
    var cities = this.context.model.get("search_params").cities;
    var data = {
      length: cities.length,
      city:
        cities.length === 1
          ? this.context.model.getDataById("cities", cities[0])
          : null
    };

    this.updateTarget({
      target: "value",
      template: "value",
      data: data
    });
    return this;
  },
  /**
   * Render list of destination options
   * If there is a user typed filter, test against the destination's name
   * @returns {DestinationsView} this
   */
  renderOptions: function() {
    var selected = this.context.model.get("search_params").cities;
    var options = this.context.model.getDataOptions("cities");
    _.each(
      options,
      function(option, index) {
        if (selected.indexOf(option.city_id) > -1) {
          option.selected = true;
        } else {
          option.selected = false;
        }

        if (
          !this.filter.trim() ||
          (this.filter.trim() &&
            option.city_name
              .toLowerCase()
              .indexOf(this.filter.trim().toLowerCase()) > -1)
        ) {
          option.show = true;
        } else {
          option.show = false;
        }
      }.bind(this)
    );

    options = _.sortBy(options, function(option) {
      return option.city_name.toLowerCase();
    });

    var content = this.templates["options"]({
      filter: this.filter,
      options: options,
      selected: selected
    });
    this.context.views["param-options"].render({ content: content });
    this.renderValue();
    return this;
  }
});

/**
 * View for Waterways
 * @extends ParamView
 */
ParamViews.waterwaysView = ParamView.extend({
  /**
   * Renders display value
   * i.e. '2 Destinations'
   * @returns {DestinationsView} this
   */
  renderValue: function() {
    var waterways = this.context.model.get("search_params").waterways;
    var data = {
      length: waterways.length,
      waterway:
        waterways.length === 1
          ? this.context.model.getDataById("waterways", waterways[0])
          : null
    };

    this.updateTarget({
      target: "value",
      template: "value",
      data: data
    });
    return this;
  },
  /**
   * Render list of destination options
   * If there is a user typed filter, test against the destination's name
   * @returns {DestinationsView} this
   */
  renderOptions: function() {
    var selected = this.context.model.get("search_params").waterways;
    var options = this.context.model.getDataOptions("waterways");

    _.each(
      options,
      function(option, index) {
        if (selected.indexOf(option.waterway_id) > -1) {
          option.selected = true;
        } else {
          option.selected = false;
        }

        if (
          !this.filter.trim() ||
          (this.filter.trim() &&
            option.waterway_name
              .toLowerCase()
              .indexOf(this.filter.trim().toLowerCase()) > -1)
        ) {
          option.show = true;
        } else {
          option.show = false;
        }
      }.bind(this)
    );

    options = _.sortBy(options, function(option) {
      return option.waterway_name.toLowerCase();
    });

    var content = this.templates["options"]({
      filter: this.filter,
      options: options,
      selected: selected
    });
    this.context.views["param-options"].render({ content: content });
    this.renderValue();
    return this;
  }
});

/**
 * View for cruise duration/nights/length
 * @extends ParamView
 */
ParamViews.durationView = ParamView.extend({
  /**
   * Renders display value
   * i.e. '0-365 Nights', '1 Night'
   * @returns {DurationView} this
   */
  renderValue: function() {
    this.updateTarget({
      target: "value",
      template: "value",
      data: this.context.model.get("search_params").duration
    });
    return this;
  },
  /**
   * Render duration length controls
   * @returns {DurationView} this
   */
  renderOptions: function() {
    var duration = this.context.model.get("search_params").duration;
    var content = this.templates["options"]({
      min: duration.min,
      max: duration.max
    });
    this.context.views["param-options"].render({ content: content });
    this.renderValue();
    return this;
  },
  /**
   * Reset duration back to original parameters
   * @returns {DurationView} this
   */
  reset: function() {
    this.context.model.get("search_params")[this.name].min = duration_min;
    this.context.model.get("search_params")[this.name].max = duration_max;
    if (this.context.model.get("active_param") === this.name) {
      this.renderOptions();
    } else {
      this.renderValue();
    }
    return this;
  }
});

/**
 * View for embarkation ports
 * @extends ParamView
 */
ParamViews.embarkationPortsView = ParamView.extend({
  /**
   * Renders display value
   * i.e. '2 Embarkation Ports'
   * @returns {EmbarkationPortsView} this
   */
  renderValue: function() {
    var ports = this.context.model.get("search_params").embarkationPorts;
    var data = {
      length: ports.length,
      port:
        ports.length === 1
          ? this.context.model.getDataById("embarkationPorts", ports[0])
          : null
    };

    this.updateTarget({
      target: "value",
      template: "value",
      data: data
    });
    return this;
  },
  /**
   * Render list of embarcation port options
   * If there is a user typed filter, test against the port's name
   * @returns {EmbarkationPortsView} this
   */
  renderOptions: function() {
    var surrounding = this.context.model.get("search_params")
      .surroundingEmbarkationPorts;
    var selected = this.context.model.get("search_params").embarkationPorts;
    var options = this.context.model.getDataOptions("embarkationPorts");

    _.each(
      options,
      function(option, index) {
        if (selected.indexOf(option.port_id) > -1) {
          option.selected = true;
        } else {
          option.selected = false;
        }

        if (
          !this.filter.trim() ||
          (this.filter.trim() &&
            option.port_name
              .toLowerCase()
              .indexOf(this.filter.trim().toLowerCase()) > -1)
        ) {
          option.show = true;
        } else {
          option.show = false;
        }
      }.bind(this)
    );

    var content = this.templates["options"]({
      filter: this.filter,
      options: options,
      selected: selected,
      surrounding: surrounding
    });
    this.context.views["param-options"].render({ content: content });
    this.renderValue();
    return this;
  }
});

/**
 * View for ports of call
 * @extends ParamView
 */
ParamViews.portsOfCallView = ParamView.extend({
  /**
   * Renders display value
   * i.e. '2 Ports of Call'
   * @returns {PortsOfCallView} this
   */
  renderValue: function() {
    var ports = this.context.model.get("search_params").portsOfCall;
    var data = {
      length: ports.length,
      port:
        ports.length === 1
          ? this.context.model.getDataById("portsOfCall", ports[0])
          : null
    };

    this.updateTarget({
      target: "value",
      template: "value",
      data: data
    });
    return this;
  },
  /**
   * Render list of ports of call options
   * If there is a user typed filter, test against the port's name
   * @returns {PortsOfCallView} this
   */
  renderOptions: function() {
    var selected = this.context.model.get("search_params").portsOfCall;
    var options = this.context.model.getDataOptions("portsOfCall");

    _.each(
      options,
      function(option, index) {
        if (selected.indexOf(option.port_id) > -1) {
          option.selected = true;
        } else {
          option.selected = false;
        }

        if (
          !this.filter.trim() ||
          (this.filter.trim() &&
            option.port_name
              .toLowerCase()
              .indexOf(this.filter.trim().toLowerCase()) > -1)
        ) {
          option.show = true;
        } else {
          option.show = false;
        }
      }.bind(this)
    );

    var content = this.templates["options"]({
      filter: this.filter,
      options: options,
      selected: selected
    });
    this.context.views["param-options"].render({ content: content });
    this.renderValue();
    return this;
  }
});

/**
 * View for cruise duration/nights/length
 * @extends ParamView
 */
ParamViews.cabinView = ParamView.extend({
  /**
   * Renders display value
   * i.e. '0-365 Nights', '1 Night'
   * @returns {DurationView} this
   */
  renderValue: function() {
    this.updateTarget({
      target: "value",
      template: "value",
      data: this.context.model.get("search_params").cabin
    });
    return this;
  },
  /**
   * Render duration length controls
   * @returns {DurationView} this
   */
  renderOptions: function() {
    var cabin = this.context.model.get("search_params").cabin;
    var content = this.templates["options"]({ cabin: cabin });
    this.context.views["param-options"].render({ content: content });
    this.renderValue();
    return this;
  },
  /**
   * Reset duration back to original parameters
   * @returns {DurationView} this
   */
  reset: function() {
    this.context.model.get("search_params")[this.name] = cabin_default;
    this.context.model.trigger("changed_param");
    if (this.context.model.get("active_param") === this.name) {
      this.renderOptions();
    } else {
      this.renderValue();
    }
    return this;
  }
});

/**
 * View for vendor sailing identifier
 * @extends ParamView
 */
ParamViews.identifierView = ParamView.extend({
  reset: function() {
    this.$el.val("");
  }
});

/**
 * View for cruise marketing code
 * @extends ParamView
 */
ParamViews.marketingCodeView = Backbone.View.extend({
  /**
   * Initializes the view
   * Sets name and context
   * @param {object} options
   * @returns {marketingCodeView} this
   */
  initialize: function(options) {
    var options = options || {};
    this.name = this.$el.attr("data-param");
    this.context = options.context ? options.context : {};
    return this;
  },
  events: {
    "blur [data-marketing-code]": "updateMarketingCode"
  },
  /**
   * Runs when search type is changed
   * @returns {marketingCode} this
   */
  updateMarketingCode: function(e) {
    $("[data-marketing-code-input]").val($(e.target).val());
    this.context.model.get("search_params")["marketing_code"] = $(
      e.target
    ).val();
    return this;
  },
  /**
   * Sets the search type in DOM programatically
   * Used by Controller.reset()
   * @returns {marketingCodeView} this
   */
  reset: function() {
    this.$("[data-marketing-code]").val(marketing_code_default);
    $("[data-marketing-code-input]").val(marketing_code_default);
    this.context.model.get("search_params")[
      "marketing_code"
    ] = marketing_code_default;
    return this;
  }
});

/**
 * View for parameter options, used by all parameters
 */
var ParamOptionsView = Backbone.View.extend({
  /**
   * Initializes view, sets empty timeouts
   * @param {object} options
   */
  initialize: function(options) {
    var options = options || {};
    this.context = options.context ? options.context : {};
    this.filterTimeout = null;
    this.durationTypeout = null;
    this.cabinTypeout = null;
    this.previousParam = null;
    this.activeTarget = null;
  },
  /**
   * Events that handle multiple types of parameters
   */
  events: {
    "click [data-option-reset]": "reset",
    "click [data-option-id]": "toggleOption",
    "input [data-option-filter]": "filter",
    "click [data-search-param-close]": "closeParam",
    "click [data-duration-action]": "changeDuration",
    "input [data-duration-value]": "inputDuration",
    "input [data-cabin-value]": "inputCabin",
    "blur [data-duration-value]": "blurDuration",
    "click [data-duration-focus]": "focusDuration",
    "click [data-cabin-focus]": "focusCabin",
    "click [data-cabin-action]": "changeCabin",
    "change [data-embarkation-surrounding]": "toggleSurrounding"
  },
  /**
   * Runs when reset button is clicked
   * Runs the currently active parameter's reset
   * @returns {ParamOptionsView} this
   */
  reset: function() {
    if (this.context.model.get("active_param")) {
      this.context.views[this.context.model.get("active_param")].reset();
      this.context.model.trigger("changed_param");
    }
    return this;
  },
  /**
   * On click 'close' button, resets active_param
   * @param e
   * @returns {ParamOptionsView}
   */
  closeParam: function(e) {
    this.context.model.set("active_param", null);
    if (this.autoClose) {
      $("body").removeClass("close-search-on-outside-click");
    }
    return this;
  },
  /**
   * Runs when an option from a list type parameter is clicked (vendors, ships, etc)
   * @param {Event} e
   * @returns {ParamOptionsView} this
   */
  toggleOption: function(e) {
    // Gets the ID, parameter, and parameter's view
    var option_id = +$(e.currentTarget).attr("data-option-id");
    var param = this.context.model.get("search_params")[
      this.context.model.get("active_param")
    ];
    var view = this.context.views[this.context.model.get("active_param")];

    if (!isNaN(option_id)) {
      var index = param.indexOf(option_id);

      // If was not selected, add
      if (index < 0) {
        param.push(option_id);
      } else {
        // If was already selected, remove
        param.splice(index, 1);
      }
    }

    // Trigger change events
    this.context.model.trigger(
      "changed_" + this.context.model.get("active_param")
    );
    this.context.model.trigger("changed_param");

    // Find out what the current scroll is and
    // store in temp var.
    var currentElementParrent = $(e.currentTarget).parents(
      "[data-option-scroll]"
    );
    if (currentElementParrent[0]) {
      var scrollableOffset = currentElementParrent[0].scrollTop;
      var scrollableOffset2 = currentElementParrent.parent()[0].scrollTop;
      this._currentScroll =
        scrollableOffset > scrollableOffset2
          ? scrollableOffset
          : scrollableOffset2;
    }

    // Re-render view
    view.renderOptions();
    return this;
  },
  /**
   * Runs when the filter textbox is changed for a list type parameter (vendors, ships, etc)
   * @returns {ParamOptionsView} this
   */
  filter: function(e) {
    // If filter is unchanged, goes away
    if (
      this.context.views[this.context.model.get("active_param")].filter ===
      e.target.value
    ) {
      return this;
    }

    // Reset timeout
    if (this.filterTimeout) {
      clearTimeout(this.filterTimeout);
    }
    // Waits until the user stops typing to apply filter
    this.filterTimeout = setTimeout(this.doFilter.bind(this), 400);
    return this;
  },
  getActiveFilter: function() {
    if (this.$el.length === 1) {
      return this.$("[data-option-filter]");
    }

    var selector = this.$el.filter(
      function(i, a) {
        return $(a)
          .parents("[data-param-options-group]")
          .find('[data-param="' + this.context.model.get("active_param") + '"]')
          .length
          ? true
          : false;
      }.bind(this)
    );

    return selector.find(
      '[data-option-filter="' + this.context.model.get("active_param") + '"]'
    );
  },
  /**
   * Runs when user stops typing in filter
   * Sets view's filter and re-renders it, and refocuses on filter textbox
   * @returns {ParamOptionsView} this
   */
  doFilter: function() {
    // Get view and set filter value
    var view = this.context.views[this.context.model.get("active_param")];
    var $filter = $(this.getActiveFilter());
    var position = null;
    view.filter = $filter.val();

    // Get input cursor position
    if (typeof $filter[0].selectionStart !== "undefined") {
      position = $filter[0].selectionStart;
    } else if (window.document.selection) {
      var range = window.document.selection.createRange();
      range.moveStart("character", -$filter[0].value.length);
      position = range.text.length;
    }

    // Re-render
    view.renderOptions();

    // Re-focus input
    this.focusInput($(this.getActiveFilter()), position);
    return this;
  },
  /**
   * Runs when a duration control is clicked
   * @param {Event} e
   * @returns {ParamOptionsView} this
   */
  changeDuration: function(e) {
    // Gets the element, active parameter (duration), parameter's view, duration type (min/max) and action (less/more)
    var $control = $(e.currentTarget);
    var param = this.context.model.get("search_params")[
      this.context.model.get("active_param")
    ];
    var view = this.context.views[this.context.model.get("active_param")];
    var type = $control.attr("data-duration-type") || null;
    var action = $control.attr("data-duration-action") || null;

    // Decrease min duration, down to 0
    if (type === "min" && action == "less") {
      if (param.min > 0) {
        param.min = param.min - 1;
      }
    } else if (type === "min" && action == "more") {
      // Increase min duration, up to 365
      // If it becomes more than max duration, update max duration as well
      param.min = param.min + 1;
      if (param.min > 365) {
        param.min = 365;
      }
      if (param.min > param.max) {
        param.max = param.min;
      }
    } else if (type === "max" && action == "less") {
      // Decrease max duration, down to 0
      // If it becomes less than min duration, update min duration as well
      param.max = param.max - 1;
      if (param.max < 0) {
        param.max = 0;
      }
      if (param.max < param.min) {
        param.min = param.max;
      }
    } else if (type === "max" && action == "more") {
      // Increase max duration, up to 365
      param.max = param.max + 1;
      if (param.max > 365) {
        param.max = 365;
      }
    }

    // Trigger change events
    this.context.model.trigger(
      "changed_" + this.context.model.get("active_param")
    );
    this.context.model.trigger("changed_param");

    // Re-render
    view.renderOptions();
    return this;
  },
  /**
   * Runs when a duration control is clicked
   * @param {Event} e
   * @returns {ParamOptionsView} this
   */
  changeCabin: function(e) {
    // Gets the element, active parameter (duration), parameter's view, duration type (min/max) and action (less/more)
    var $control = $(e.currentTarget);
    var search_params = this.context.model.get("search_params");
    var param = search_params[this.context.model.get("active_param")];
    var view = this.context.views[this.context.model.get("active_param")];
    var action = $control.attr("data-cabin-action") || null;
    var min = view.$el.data("min");
    var max = view.$el.data("max");

    //Adds up if value is below current max and action is add.
    if (action == "more" && param < max) {
      param++;
    }

    //Reduces if value is above current min and action is less.
    if (action == "less" && param > min) {
      param--;
    }

    //Updates model with new value
    search_params[this.context.model.get("active_param")] = param;
    this.context.model.set("search_params", search_params);

    // Trigger change events
    this.context.model.trigger(
      "changed_" + this.context.model.get("active_param")
    );
    this.context.model.trigger("changed_param");

    // Re-render
    view.renderOptions();
    return this;
  },

  blurCabin: function(e) {
    var $control = $(e.currentTarget);
    var param = this.context.model.get("search_params")[
      this.context.model.get("active_param")
    ];
    $control.val(param.toString());
    return this;
  },

  inputCabin: function(e) {
    // Resets timeout
    if (this.durationTimeout) {
      clearTimeout(this.durationTimeout);
    }
    // Waits until user stops typing to change cabin
    this.durationTimeout = setTimeout(this.doInputCabin.bind(this, e), 400);
    return this;
  },

  doInputCabin: function(e) {
    // Get the element, active parameter (cabin), parameter's view,  and cleans input value
    var $control = $(e.currentTarget);
    var search_params = this.context.model.get("search_params");
    var param = this.context.model.get("search_params")[
      this.context.model.get("active_param")
    ];
    var view = this.context.views[this.context.model.get("active_param")];
    var value = parseInt($control.val().replace(/[^\d]/g, ""));
    var position = null;

    if (!$control.val().trim()) {
      return this;
    }

    // Get input cursor position
    if (typeof $control[0].selectionStart !== "undefined") {
      position = $control[0].selectionStart;
    } else if (window.document.selection) {
      var range = window.document.selection.createRange();
      range.moveStart("character", -$control[0].value.length);
      position = range.text.length;
    }

    // If invalid input, don't change
    if (isNaN(value)) {
      value = param;
    } else if (value > 4) {
      // Limit 4
      value = 4;
    } else if (value < 1) {
      //limit 1
      value = 1;
    }
    // Update param
    param = value;

    // Update input value
    if ($control.val() && $control.val() != value) {
      $control.val(value);
    }

    //Updates model with new value
    search_params[this.context.model.get("active_param")] = param;
    this.context.model.set("search_params", search_params);

    // Trigger change events
    this.context.model.trigger(
      "changed_" + this.context.model.get("active_param")
    );
    this.context.model.trigger("changed_param");

    // Re-render display value
    view.renderOptions();

    // Re-focus input
    $control = this.$('[data-cabin-value="cabin"]');
    this.focusInput($control, position);

    return this;
  },

  /**
   * Runs when duration input is changed
   * @param {Event} e
   * @returns {ParamOptionsView} this
   */
  inputDuration: function(e) {
    // Resets timeout
    if (this.durationTimeout) {
      clearTimeout(this.durationTimeout);
    }
    // Waits until user stops typing to change duration
    this.durationTimeout = setTimeout(this.doInputDuration.bind(this, e), 400);
    return this;
  },

  /**
   * Runs when duration input is blurred
   * If the input was blank, set the current value back
   * @param {Event} e
   * @returns {ParamOptionsView} this
   */
  blurDuration: function(e) {
    var $control = $(e.currentTarget);
    var param = this.context.model.get("search_params")[
      this.context.model.get("active_param")
    ];
    var type = $control.attr("data-duration-value") || null;

    if (type) {
      $control.val(param[type].toString());
    }

    return this;
  },

  /**
   * Runs when user stops typing in duration input
   * @param {Event} e
   * @returns {ParamOptionsView} this
   */
  doInputDuration: function(e) {
    // Get the element, active parameter (duration), parameter's view, duration type (min/max), and cleans input value
    var $control = $(e.currentTarget);
    var param = this.context.model.get("search_params")[
      this.context.model.get("active_param")
    ];
    var view = this.context.views[this.context.model.get("active_param")];
    var type = $control.attr("data-duration-value") || null;
    var value = parseInt($control.val().replace(/[^\d]/g, ""));
    var position = null;

    if (!$control.val().trim()) {
      return this;
    }

    // Get input cursor position
    if (typeof $control[0].selectionStart !== "undefined") {
      position = $control[0].selectionStart;
    } else if (window.document.selection) {
      var range = window.document.selection.createRange();
      range.moveStart("character", -$control[0].value.length);
      position = range.text.length;
    }

    // If invalid input, don't change
    if (isNaN(value)) {
      value = param[type];
    } else if (value > 365) {
      // Limit 365
      value = 365;
    }

    // If typing in min and greater than current max, update max
    if (type === "min" && value > param.max) {
      param.max = value;
    } else if (type === "max" && value < param.min) {
      // If typing in max and greater than current max, update max
      param.min = value;
    }

    // Update param
    param[type] = value;

    // Update input value
    if ($control.val() && $control.val() != value) {
      $control.val(value);
    }

    // Trigger change events
    this.context.model.trigger(
      "changed_" + this.context.model.get("active_param")
    );
    this.context.model.trigger("changed_param");

    // Re-render display value
    view.renderOptions();

    // Re-focus input
    $control = this.$('[data-duration-value="' + type + '"]');
    this.focusInput($control, position);

    return this;
  },
  /**
   * Focuses on specified element and moves text selection cursor to end, or specified position
   * @param {jQuery Element} $control
   * @returns {ParamOptionsView} this
   */
  focusInput: function($control, position) {
    var $control = $control || null;
    var position = position || null;
    var value = $control.val();

    if (typeof position === "number" && position > value.length) {
      position = value.length;
    }

    if (typeof position === "number" && $control[0].setSelectionRange) {
      $control.focus()[0].setSelectionRange(position, position);
    } else if (
      typeof position === "number" &&
      window.document.selection &&
      $control[0].createTextRange
    ) {
      var range = $control[0].createTextRange();
      range.collapse(true);
      range.moveEnd("character", position);
      range.moveStart("character", position);
      range.select();
    } else {
      $control
        .focus()
        .val("")
        .val(value);
    }

    return this;
  },
  /**
   * Runs when label for duration input is clicked
   * @param {Event} e
   * @returns {ParamOptionsView} this
   */
  focusDuration: function(e) {
    var type = $(e.currentTarget).attr("data-duration-focus") || null;
    if (type) {
      // Highlight duration input
      this.highlightInput(this.$('[data-duration-value="' + type + '"]'));
    }
    return this;
  },
  focusCabin: function(e) {
    // Highlight cabin input
    this.highlightInput(this.$('[data-cabin-value="cabin"]'));
    return this;
  },
  /**
   * Highlights the text in specified input
   * @param {jQuery Element} $control
   * @returns {ParamOptionsView} this
   */
  highlightInput: function($control) {
    var $control = $control || null;

    if ($control.length > 0) {
      var range, selection;
      var control = $control.get(0);

      if (control.select) {
        control.select();
      } else if (control.setSelectionRange) {
        control.setSelectionRange(0, control.value.length);
      } else if (document.body.createTextRange) {
        range = document.body.createTextRange();
        range.moveToElementText($control.get(0));
        range.select();
      } else if (window.getSelection) {
        selection = window.getSelection();
        range = document.createRange();
        range.selectNodeContents($control.get(0));
        selection.removeAllRanges();
        selection.addRange(range);
      }
    }
    return this;
  },
  /**
   * Toggle surrounding embarkation ports
   * @param e
   */
  toggleSurrounding: function(e) {
    // Get active param and view
    var param = this.context.model.get("active_param");
    var view = this.context.views[param];

    // Toggle param
    this.context.model.get(
      "search_params"
    ).surroundingEmbarkationPorts = !this.context.model.get("search_params")
      .surroundingEmbarkationPorts;

    // Trigger change events
    this.context.model.trigger("changed_" + param);
    this.context.model.trigger("changed_param");

    // Re-render view
    view.renderOptions();
    return this;
  },
  /**
   * Render option view, keeps scrollbar in place if it is a rerender of same parameter
   * @param {object} options
   * @returns {ParamOptionsView} this
   */
  render: function(options) {
    var options = options || {};
    var param = this.context.model.get("active_param");
    var scroll = this.$("[data-option-scroll]");
    var modifyWidget = scroll.length == 1 ? true : false;
    var scrollTop = this._currentScroll;

    if (options.content) {
      this.$el.empty().html(options.content);

      // If this is a rerender, keep scrollbar in place
      if (this.previousParam === param) {
        scroll = this.$("[data-option-scroll]");
        if (!modifyWidget) {
          scroll.each(function() {
            $(this).parent()[0].scrollTop = scrollTop;
          });
        } else {
          scroll[0].scrollTop = scrollTop;
        }
      }
    }

    this.previousParam = param;
    return this;
  }
});

/**
 * View for parameter inputs
 * This creates the hidden form inputs for all parameters
 */
var ParamInputsView = Backbone.View.extend({
  /**
   * Initializes view
   * @param {object} options
   * @returns {ParamInputsView} this
   */
  initialize: function(options) {
    var options = options || {};
    this.context = options.context ? options.context : {};
    this.template = Handlebars.compile(
      this.$('[data-template="inputs"]').html()
    );
    this.$target = this.$('[data-target="inputs"]');

    // Whenever parameter is changed, render
    this.listenTo(this.context.model, "changed_param", this.render.bind(this));
    return this;
  },
  /**
   * Renders the hidden form inputs
   * @returns {ParamInputsView} this
   */
  render: function() {
    // JSON.parse(JSON.stringify(this.get('original_search_params')))
    var searchParams = JSON.parse(
      JSON.stringify(this.context.model.get("search_params"))
    );

    if (searchParams["countries"] && searchParams["countries"].length) {
      _.each(
        searchParams["countries"],
        function(country, i) {
          searchParams["countries"][i] = _.findWhere(
            this.context.model.get("param_options").countries,
            { country_id: country }
          )["country_code"];
        }.bind(this)
      );
    }

    var outputFormat = this.context.model.get("output_date_format");

    if ((_.has(searchParams), "start_date")) {
      // Using the current date format, reformat to output format before updating output fields.
      searchParams["start_date"] = moment(
        searchParams.start_date,
        searchParams.date_format
      ).format(outputFormat);
    }

    if ((_.has(searchParams), "end_date")) {
      // Using the current date format, reformat to output format before updating output fields.
      searchParams["end_date"] = moment(
        searchParams.end_date,
        searchParams.date_format
      ).format(outputFormat);
    }

    this.$target.empty().html(this.template(searchParams));
    return this;
  }
});

module.exports = Controller;
